import FormGroup from '~/components/form/FormGroup';
import ValibotFieldTextarea from '~/components/valibot/ValibotFieldTextarea';
import { FormHorizontal } from '~/components/form/layout';

export default function MpiPhotosSubmit() {
  return (
    <FormGroup>
      <FormHorizontal label="Notes to Editor">
        <ValibotFieldTextarea name="editor_notes" />
      </FormHorizontal>
    </FormGroup>
  );
}
